import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getUsers(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_getUserList', item, options);
  }

  public getUserInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'api/v2.0/user/ws_getUserDetails', item, options);
  }

  public addNewUser(context, lang, udid, companyInternalId, firstname, lastname, username, password, email, userImageRaw, permissionList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { companyInternalId, firstname, lastname, username, password, email, userImageRaw, permissionList };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_saveUser', item, options);
  }

  public updateUser(context, lang, udid, internalId, companyInternalId, firstname, lastname, username, email) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, companyInternalId, firstname, lastname, username, email };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_saveUser', item, options);
  }

  public deleteUser(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_deleteUser', item, options);
  }

  public updateUserImage(context, lang, udid, internalId, imageRaw) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageRaw };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_updateImageUser', item, options);
  }

  public updateUserPermissions(context, lang, udid, internalId, companyInternalId, permissionList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, companyInternalId, permissionList };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_saveUser', item, options);
  }

  public getUserCentersAndRoles(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_getUserListOfCentersAndRoles', item, options);
  }

  public updateUserPassword(context, lang, udid, internalId, newField) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, newField };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/ws_updateUserPass', item, options);
  }

  public addLoginVerificationContact(context, lang, udid, userInternalId, type, value) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { userInternalId, type, value };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/addLoginVerificationContact', item, options);
  }

  public deleteLoginVerificationContact(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/userMaintenance/deleteLoginVerificationContact', item, options);
  }

  public signIn(lang, mail, udid, password) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { mail, password };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/ws_loginUser', item, options);
  }

  public webLogin(lang, mail, udid, password) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { mail, password };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/webLogin', item, options);
  }

  public sendLoginVerificationCode(lang, udid, challengeId, contactInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { challengeId, contactInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/webLogin/sendVerificationCode', item, options);
  }

  public verifyLoginVerificationCode(lang, udid, challengeId, code) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { challengeId, code };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/webLogin/verifyCode', item, options);
  }

  public ssoMicrosoftLogin(lang, udid, token) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { token };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/sso/microsoft', item, options);
  }

  public ssoGoogleLogin(lang, udid, token) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { token };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/sso/google', item, options);
  }

  public selectCompany(tmpContext, lang, udid, companyInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', tmpContext);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { companyInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/selectCompany', item, options);
  }

  public recoveryPass(lang, udid, mail) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { mail };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/ws_recoveryPass', item, options);
  }

  public verifyPass(lang, udid, recoveryToken, newPassword) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { recoveryToken, newPassword };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/ws_verifyPass', item, options);
  }
}
